export const GRID_MOBILE = 768;
export const TOTAL_VISIBLE_COMMENTS_REVIEWS = 4;
export const REVIEW_DATE_FORMAT = 'mmm yyyy';
export const PARTNER_JOINED_FORMAT = 'mmm yyyy';

export const IMAGE_SIZE_NORMAL = 'normal';
export const IMAGE_SIZE_ORIGINAL = 'original';
export const IMAGE_SIZE_SMALL = 'small';
export const IMAGE_SIZE_THUMB = 'thumb';
export const IMAGE_SIZE_RETINA = 'retina';




// WEBPACK FOOTER //
// ./src/components/storefront/constants/index.js